module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-fr4.e502f6e.png";